export default "__VITE_ASSET__HoYw6$ya__"